var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconBarra = function SvgIconBarra(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 70,
    viewBox: "0 0 255 70",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20.0908,
    width: 10.8182,
    height: 29.3636,
    rx: 5.40909,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 49.4541,
    width: 10.8182,
    height: 29.3636,
    rx: 5.40909,
    transform: "rotate(-180 255 49.4541)",
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6819,
    y: 10.0459,
    width: 10.8182,
    height: 50.2273,
    rx: 5.40909,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 240.318,
    y: 59.5,
    width: 10.8182,
    height: 50.2273,
    rx: 5.40909,
    transform: "rotate(-180 240.318 59.5)",
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3635,
    width: 10.8182,
    height: 69.5455,
    rx: 5.40909,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 225.636,
    y: 69.5459,
    width: 10.8182,
    height: 69.5455,
    rx: 5.40909,
    transform: "rotate(-180 225.636 69.5459)",
    fill: "#C4C4C4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 44.0454,
    y1: 34.1367,
    x2: 210.954,
    y2: 34.1367,
    stroke: "#C4C4C4",
    strokeWidth: 9
  })));
};

export default __webpack_public_path__ + "static/media/IconBarra.1d325865.svg";
export { SvgIconBarra as ReactComponent };